import { motion } from "framer-motion";
import { MapPin, EnvelopeSimple, Phone, WhatsappLogo, InstagramLogo, FacebookLogo } from "@phosphor-icons/react";
import logo from "@/logo_full_light.png";

export const Contact = () => {
  return (
    <footer id="contatti" className="relative bg-brand-surface border-t border-brand-border" data-testid="contact-section">
      {/* CTA */}
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24 lg:py-36">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-outfit text-xs tracking-[0.3em] uppercase text-brand-red font-bold mb-6">— Iniziamo</p>
          <h2 className="font-anton uppercase text-[13vw] lg:text-[9vw] leading-[0.85] tracking-tight">
            Diamo forma<br />
            <span className="text-stroke-red">alla tua idea</span>
          </h2>

          <a
            href="mailto:info@new-graphic.it"
            data-testid="contact-cta-email"
            className="inline-flex items-center gap-4 mt-12 group"
          >
            <span className="h-16 w-16 lg:h-20 lg:w-20 rounded-full bg-brand-red flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <EnvelopeSimple size={30} weight="bold" className="text-white" />
            </span>
            <span className="font-outfit text-2xl lg:text-4xl font-semibold tracking-tight group-hover:text-brand-red transition-colors">
              info@new-graphic.it
            </span>
          </a>

          {/* phones */}
          <div className="mt-10 flex flex-col sm:flex-row gap-6 sm:gap-14" data-testid="contact-phones">
            <div className="flex items-center gap-4">
              <a href="tel:+393751455295" data-testid="contact-phone-grafico" className="group flex items-center gap-4">
                <span className="h-12 w-12 rounded-full border border-brand-border flex items-center justify-center group-hover:bg-brand-red group-hover:border-brand-red transition-colors duration-300">
                  <Phone size={22} weight="bold" className="text-brand-red group-hover:text-white transition-colors" />
                </span>
                <span>
                  <span className="font-outfit text-[11px] uppercase tracking-[0.25em] text-neutral-500 block">Grafico — Negrini Alan</span>
                  <span className="font-outfit text-lg lg:text-xl font-semibold tracking-tight group-hover:text-brand-red transition-colors">+39 375 145 5295</span>
                </span>
              </a>
              <a
                href="https://wa.me/393751455295"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-grafico"
                aria-label="Scrivi su WhatsApp a Negrini Alan"
                className="h-12 w-12 rounded-full bg-[#25D366] flex items-center justify-center hover:scale-110 transition-transform duration-300"
              >
                <WhatsappLogo size={26} weight="fill" className="text-white" />
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a href="tel:+393939967991" data-testid="contact-phone-amministrazione" className="group flex items-center gap-4">
                <span className="h-12 w-12 rounded-full border border-brand-border flex items-center justify-center group-hover:bg-brand-red group-hover:border-brand-red transition-colors duration-300">
                  <Phone size={22} weight="bold" className="text-brand-red group-hover:text-white transition-colors" />
                </span>
                <span>
                  <span className="font-outfit text-[11px] uppercase tracking-[0.25em] text-neutral-500 block">Amministrazione — Ferrari Elia</span>
                  <span className="font-outfit text-lg lg:text-xl font-semibold tracking-tight group-hover:text-brand-red transition-colors">+39 393 996 7991</span>
                </span>
              </a>
            </div>
          </div>
        </motion.div>

        {/* info grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-24 pt-12 border-t border-brand-border">
          <div data-testid="contact-address">
            <div className="flex items-center gap-2 text-brand-red mb-4">
              <MapPin size={20} weight="fill" />
              <span className="font-outfit text-xs uppercase tracking-widest">Dove siamo</span>
            </div>
            <p className="font-manrope text-neutral-300 leading-relaxed">
              Via Consorzio Valgella, snc<br />
              23036 Teglio (SO)<br />
              Valtellina — Italia
            </p>
          </div>

          <div data-testid="contact-hours">
            <div className="flex items-center gap-2 text-brand-red mb-4">
              <span className="font-outfit text-xs uppercase tracking-widest">Orari</span>
            </div>
            <p className="font-manrope text-neutral-300 leading-relaxed">
              Lun — Ven: 08:30 / 18:00<br />
              Sabato: su appuntamento<br />
              Domenica: chiuso
            </p>
          </div>

          <div data-testid="contact-social">
            <div className="flex items-center gap-2 text-brand-red mb-4">
              <span className="font-outfit text-xs uppercase tracking-widest">Seguici</span>
            </div>
            <div className="flex gap-3">
              <a href="#" data-testid="social-instagram" className="h-11 w-11 rounded-full border border-brand-border flex items-center justify-center text-neutral-300 hover:bg-brand-red hover:border-brand-red hover:text-white transition-colors">
                <InstagramLogo size={22} />
              </a>
              <a href="#" data-testid="social-facebook" className="h-11 w-11 rounded-full border border-brand-border flex items-center justify-center text-neutral-300 hover:bg-brand-red hover:border-brand-red hover:text-white transition-colors">
                <FacebookLogo size={22} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* bottom bar */}
      <div className="border-t border-brand-border">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <img src={logo} alt="New Graphic — Visual Communication" className="h-8 w-auto object-contain" />
          <p className="font-manrope text-xs text-neutral-500">
            © {new Date().getFullYear()} New Graphic — Visual Communication. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};
